export default [{
        path: '/my',
        name: 'my',
        component: resolve => require(['../../view/my/my.vue'], resolve),
        meta: { 
            navShow: true,
            keepAlive: false // 需要缓存
        },
    },
    {
        path: '/setUpHe',
        name: 'setUpHe',
        component: resolve => require(['../../view/my/setup/setUpHe.vue'], resolve),
    },
    {
        path: '/Account',
        name: 'Account',
        component: resolve => require(['../../view/my/setup/Account.vue'], resolve),
    },
    {
        path: '/replacePhone',
        name: 'replacePhone',
        component: resolve => require(['../../view/my/setup/replacePhone.vue'], resolve),
    },
    {
        path: '/changePassword',
        name: 'changePassword',
        component: resolve => require(['../../view/my/setup/changePassword.vue'], resolve),
    },
    {
        path: '/feedback',
        name: 'feedback',
        component: resolve => require(['../../view/my/setup/feedback.vue'], resolve),
    },
    {
        path: '/userData',
        name: 'userData',
        component: resolve => require(['../../view/my/userData/userData.vue'], resolve),
    },
    {
        path: '/focus',
        name: 'focus',
        component: resolve => require(['../../view/my/userData/focus.vue'], resolve),
    },
    {
        path: '/myFans',
        name: 'myFans',
        component: resolve => require(['../../view/my/userData/myFans.vue'], resolve),
    },
    {
        path: '/catCoin',
        name: 'catCoin',
        component: resolve => require(['../../view/my/userData/catCoin.vue'], resolve),
    },
    {
        path: '/integralDetail',
        name: 'integralDetail',
        component: resolve => require(['../../view/my/userData/integralDetail.vue'], resolve),
    },
    {
        path: '/nickname',
        name: 'nickname',
        component: resolve => require(['../../view/my/userData/nickname.vue'], resolve),
    },
    {
        path: '/signature',
        name: 'signature',
        component: resolve => require(['../../view/my/userData/signature.vue'], resolve),
    },
    {
        path: '/everyDay',
        name: 'everyDay',
        component: resolve => require(['../../view/my/daily/everyDay.vue'], resolve),
    },
    {
        path: '/vipExchangea',
        name: 'vipExchangea',
        component: resolve => require(['../../view/my/daily/vipExchangea.vue'], resolve),
    },
    {
        path: '/promote',
        name: 'promote',
        component: resolve => require(['../../view/my/daily/promote.vue'], resolve),
    },
    {
        path: '/task',
        name: 'task',
        component: resolve => require(['../../view/my/daily/task.vue'], resolve),
    },
    {
        path: '/share',
        name: 'share',
        component: resolve => require(['../../view/my/daily/share.vue'], resolve),
    },
    {
        path: '/invitationList',
        name: 'invitationList',
        component: resolve => require(['../../view/my/daily/invitationList.vue'], resolve),
    },
    {
        path: '/classification',
        name: 'classification',
        component: resolve => require(["../../view/Vocal_Novels/classification.vue"], resolve),
    },
    {
        path: '/search',
        name: 'search',
        component: resolve => require(["../../view/Vocal_Novels/search.vue"], resolve),
    },
    {
        path: '/myComments',
        name: 'myComments',
        component: resolve => require(["../../view/my/myComments/myComments.vue"], resolve),
    },
    {
        path: '/myGive',
        name: 'myGive',
        component: resolve => require(["../../view/my/myGive/myGive.vue"], resolve),
    },
    {
        path: '/myCollection',
        name: 'myCollection',
        component: resolve => require(["../../view/my/myCollection/myCollection.vue"], resolve),
    },
    {
        path: '/history',
        name: 'history',
        component: resolve => require(["../../view/my/history/history.vue"], resolve),
    },
    {
        path: '/myPost',
        name: 'myPost',
        component: resolve => require(["../../view/my/myPost/myPost.vue"], resolve),
    },
    {
        path: '/faq',
        name: 'faq',
        component: resolve => require(["../../view/my/faq/faq.vue"], resolve),
    },
    {
        path: "/integral",
        name: 'integral',
        component: resolve => require(["../../view/my/faq/integral.vue"], resolve),
    },
    {
        path: '/VipRole',
        name: 'VipRole',
        component: resolve => require(["../../view/my/faq/VipRole.vue"], resolve),
    },
    {
        path: '/problem',
        name: 'problem',
        component: resolve => require(["../../view/my/faq/problem.vue"], resolve),
    },
    {
        path: '/Howto',
        name: 'Howto',
        component: resolve => require(["../../view/my/faq/Howto.vue"], resolve),
    },
    {
        path: '/faqVideo',
        name: 'faqVideo',
        component: resolve => require(["../../view/my/faq/faqVideo.vue"], resolve),
    },
    {
        path: "/obtain",
        name: "obtain",
        component: resolve => require(["../../view/my/faq/obtain.vue"], resolve),
    },
    {
        path: "/forget",
        name: "forget",
        component: resolve => require(["../../view/my/faq/forget.vue"], resolve),
    },
    {
        path: "/login",
        name: "login",
        component: resolve => require(["../../view/my/faq/login.vue"], resolve),
    },
    {
        path: "/quhao",
        name: "quhao",
        component: resolve => require(["../../view/my/faq/quhao.vue"], resolve),
    },
    {
        path: "/register",
        name: "register",
        component: resolve => require(["../../view/my/faq/register.vue"], resolve),
    },
    {
        path: "/olduser",
        name: "olduser",
        component: resolve => require(["../../view/my/faq/olduser.vue"], resolve),
    },
    {
        path: "/forgot",
        name: "forgot",
        component: resolve => require(["../../view/my/faq/forgot.vue"], resolve),
    },
    {
        path: "/finish",
        name: "finish",
        component: resolve => require(["../../view/my/faq/registerfinish.vue"], resolve),
    },
    {
        path: "/line",
        name: "line",
        component: resolve => require(["../../view/my/line.vue"], resolve),
    },
    {
        path: "/binding",
        name: "binding",
        component: resolve => require(["../../view/my/faq/binding.vue"], resolve),
    },
    {
        path: "/mymedal",
        name: "mymedal",
        component: resolve => require(["../../view/my/medal/mymedal.vue"], resolve),
    },
    {
        path: "/detailed",
        name: "detailed",
        component: resolve => require(["../../view/my/medal/detailed.vue"], resolve),
    },
]


// WEBPACK FOOTER //
// ./src/router/my/index.js